import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { LOGOS, USA } = DEFAULT
const { CONTENT_WITH_ELIGIBILITY_V2: content, CONFIG_WITH_ELIGIBILITY_V2 } = USA

const partnerName = 'Presbyterian UltraFlex Medicare Advantage B360'

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_ELIGIBILITY_V2,
    id: 'presbyterian-ultra-flex-medicare-advantage-b-360',
    productConfigAppName: 'presbyterian-ultra-flex-medicare-advantage-b-360',
    name: partnerName,
    codes: {
      membership: 'PHPUFAUTOAPP',
    },
    partnerUrlSlug: 'phpuf',
    useDnaV2Design: true,
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
  content,
}

export default [baseConfig, baseConfigWithDnaV2Design]
